import Phaser from 'phaser';
import { CST } from '../CST';
import $ from 'jquery';
import buttonBehaviours from '../helpers/button-behaviours';
import { hideTextFields, showTextFields } from '../helpers/text-fields';

export default class Verify2FA extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.VERIFY2FA);
	}

	preload() {
		this.load.image('bg', 'assets/english/bg.png');
		this.load.image('popup-2fa-leadership', 'assets/popup-2fa-leadership.png');
		this.load.image('btn-login', 'assets/btn-login.png');
		this.load.image('back_btn', 'assets/english/go-backwards.png');
		this.load.image('error-code', 'assets/english/error/error-code.png');
		this.load.image('error-generic', 'assets/english/error/error-generic.png');
		this.load.html('html-verification-code', 'html/verification-code.html');
	}

	create() {
		const cx = this.cameras.main.width / 2;
		const cy = this.cameras.main.height / 2;

		this.add.image(cx, cy, 'bg');
		this.add.image(cx, cy, 'popup-2fa-leadership');

		this.verificationCode = this.add.dom(cx, cy + 40).createFromCache('html-verification-code');
		this.verificationCode = this.verificationCode.getChildByName('verificationCode');

		this.btnVerify = this.add
			.image(cx, cy + 150, 'btn-login')
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () =>
				buttonBehaviours.pushOnClick(this, this.btnVerify, () => {
					this.verify();
				}),
			);

		this.btnBack = this.add
			.image(90, cy + 410, 'back_btn')
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () =>
				buttonBehaviours.pushOnClick(this, this.btnBack, () => {
					this.scene.start(CST.SCENES.LOGIN);
				}),
			)
			.setScale(1.5);
	}

	verify() {
		let self = this;

		$.ajax({
			async: false,
			type: 'post',
			url: 'website/verify-2fa.php',
			data: {
				email: localStorage.getItem('2fa_email'),
				code: this.verificationCode.value,
			},
			dataType: 'JSON',
			success(response) {
				if (response[0] === 400) {
					hideTextFields([self.verificationCode]);
					buttonBehaviours.disableInteraction([self.btnVerify, self.btnBack]);

					const error = self.add.image(
						self.cameras.main.width / 2,
						self.cameras.main.height / 2 - 175,
						response[1],
					);

					setTimeout(() => {
						showTextFields([self.verificationCode]);
						buttonBehaviours.enableInteraction([self.btnVerify, self.btnBack]);
						error.destroy();
					}, 2000);
				} else {
					localStorage.removeItem('2fa_email');
					localStorage.setItem('jwt', response[1]);
					if (response[2]) {
						localStorage.setItem('admin', true);
						self.scene.start(CST.SCENES.MENU);
					} else {
						self.scene.start(CST.SCENES.LICENSEEXPIRED, { isOrg: response[3] });
					}
				}
			},
			error(error) {
				console.log(error);
			},
		}).responseJSON;
	}
}

